const ru = new Map([
    ['card_number', 'номер карты'],
    ['card_holder', 'владелец карты'],
    ['month', 'месяц'],
    ['year', 'год'],
    ['cvv', 'CVV'],
    ['month_placeholder', '00'],
    ['year_placeholder', '00'],
    ['submit', 'Оплатить'],
    ['submit_ac', 'Пополнить'],
    ['success', 'Успешно оплачено'],
    ['fail', 'Не оплачено'],
    ['label_text_account', 'Перевод на кошелек:'],
    ['label_text_amount', 'Сумма'],
    ['label_text_comment', 'С комментарием:'],
    ['copy_text_title', 'Копировать'],
    ['copy_text_confirm', 'Скопировано'],


    // validation locales
    ['required_field_error', 'обязательное'],
    ['incorrect_field_error', 'некорректное'],
    ['incorrect_card', 'неверный номер карты'],
    ['min_value_field_error', 'недействителен']
]);

const uk = new Map([
    ['card_number', 'номер карти'],
    ['card_holder', 'власник карти'],
    ['month', 'місяць'],
    ['year', 'рік'],
    ['cvv', 'CVV'],
    ['month_placeholder', '00'],
    ['year_placeholder', '00'],
    ['submit', 'Оплатити'],
    ['submit_ac', 'Поповнити'],
    ['success', 'Успішно оплачено'],
    ['fail', 'Не оплачено'],
    ['label_text_account', 'Переклад на гаманець:'],
    ['label_text_amount', 'Сума:'],
    ['label_text_comment', 'З коментарем:'],
    ['copy_text_title', 'Копіювати'],
    ['copy_text_confirm', 'Скопійовано'],

    // validation locales
    ['required_field_error', 'обов\'язкове'],
    ['incorrect_field_error', 'некоректне'],
    ['incorrect_card', 'невірний номер картки'],
    ['min_value_field_error', 'недійсний']
]);

const en = new Map([
    ['card_number', 'card number'],
    ['card_holder', 'card holder'],
    ['month', 'month'],
    ['year', 'year'],
    ['cvv', 'CVV'],
    ['month_placeholder', '00'],
    ['year_placeholder', '00'],
    ['submit', 'Submit'],
    ['submit_ac', 'Deposit'],
    ['success', 'Successfully paid'],
    ['fail', 'Failed paid'],
    ['label_text_account', 'Transfer to wallet:'],
    ['label_text_amount', 'Amount:'],
    ['label_text_comment', 'With comment:'],
    ['copy_text_title', 'Copy'],
    ['copy_text_confirm', 'Copied'],

    // validation locales
    ['required_field_error', 'required'],
    ['incorrect_field_error', 'incorrect'],
    ['incorrect_card', 'incorrect card number'],
    ['min_value_field_error', 'invalid']
]);


export const LOCALIZATION = {
    ru,
    uk,
    en
};
